

export const STATUSES = [
  {
    text: 'Open',
    value: 'OPEN',
  },

  {
    text: 'Hidden',
    value: 'HIDDEN',
  },

  {
    text: 'Closed',
    value: 'CLOSED',
  },
];

export const INTERVALS = [
  {
    text: 'Daily',
    value: 'DAILY',
  },
  {
    text: 'Weekly',
    value: 'WEEKLY',
  },
  {
    text: 'Monthly',
    value: 'MONTHLY',
  },
];

export const TICKETS_STUB = [
  {
    id: 1,
    firstName: 'Advanced Child',
    lName: '',
    type: '',
    quantity: '',
    email: '',
  },
  {
    id: 2,
    firstName: 'General Adult',
    lName: '',
    type: '',
    quantity: '',
    email: '',
  },
  {
    id: 3,
    firstName: 'VIP',
    lName: '',
    type: '',
    quantity: '',
    email: '',
  },
];

export const ITEMS_PER_PAGE = [
  {
    text: '10',
    value: '10',
  },
  {
    text: '50',
    value: '50',
  },
  {
    text: '100',
    value: '100',
  },
  {
    text: '150',
    value: '150',
  },
  {
    text: '200',
    value: '200',
  },
];

export const DURATION_LIST = [
  {
    text: 'Last Year',
    value: 'last-year',
  },
  {
    text: 'Last Month',
    value: 'last-month',
  },
  {
    text: 'Last Week',
    value: 'last-week',
  },
  {
    text: 'Yesterday',
    value: 'yesterday',
  },
];

export const SALUTATION_OPTIONS = [
  {value: 'Mr.', text: 'Mr.'},
  {value: 'Mrs.', text: 'Mrs.'},
  {value: 'Ms.', text: 'Ms.'},
  {value: 'Dr.', text: 'Dr.'},
];

// Used to identify the script tag where the form injection code goes
export const EMBED_SCRIPT_ID = 'donation-embed-script';

